module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_2.44a5a728.jpg";